import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { postData } from '../lib/utils';
import { toTitleCase } from '../lib/common';

function SignUp() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password:'',
    companyName: '',
    websiteUrl: '',
    companySize: '',
    mediaType: [],
    jobType: '',
    numberOfClients: '',
    projectSize: '',
    deliveryType: [],
    heardOption: ''
  });

  const navigate = useNavigate();

  const companySize = ["Solo", "2-5", "5+"];
  const jobType = ["Video only", "Video + Photo(Hybrid)"];
  const numberOfClients = ["1-10", "11-50", "50+"];
  const projectSize = ["less than 10GB", "10-25GB", "25-50GB", "50GB+"];
  const typesOfMedia = [
    "Weddings & Life-Events",
    "Theatre Performances & Dance Recitals",
    "Commercial Projects",
    "Real Estate",
    "Educational Videos & Courses"
  ];
  const deliveryType = [
    "USB",
    "DVD/Blu-ray",
    "Vimeo",
    "Dropbox or Google Drive",
    "WeTransfer",
    "Mediazilla",
    "Eazyflicks",
    "Pixieset",
    "Other"
  ];
  const heardOption = [
    "Google Search",
    "Instagram",
    "Facebook",
    "Friend or Family",
    "YouTube",
    "Advertisement",
    "Other"
  ];

  useEffect(() => {
    localStorage.removeItem('token');
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === 'checkbox') {
      setFormData(prevData => ({
        ...prevData,
        [name]: checked
          ? [...prevData[name], value]
          : prevData[name].filter(val => val !== value),
      }));
    } else if (type === 'radio') {
      setFormData(prevData => ({
        ...prevData,
        [name]: value,
      }));
    } else {
      setFormData(prevData => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    

    // You can make API calls here
     const response = await postData("admin/register", formData); 
    if(response.user) {
        alert("Thank you for your submission. We are currently reviewing your request, and the process may take up to 48 hours. We appreciate your patience and understanding during this time.")
      
        console.log(response.user)
         
        const sentMail = await postData("users/sentMail", {
            to: response.user.email,
            subject: 'Submission Received – Review in Progress', // updated subject
            html: `
              <p>Dear ${toTitleCase(response.user.name)},</p>
              <p><strong>Thank you for your submission.</strong></p>
              <p>We are currently reviewing your request, and the process may take up to <strong>48 hours</strong>.</p>
              <p>We appreciate your <em>patience</em> and understanding during this time.</p>
              <br/>
              <p>Best regards,<br/><strong>Sadha Video Team</strong></p>
            `
          });
          
          
       console.log("SENT Mail ",sentMail)
       if(sentMail.message)
       {
        navigate("/login");
       }
    }
    else
    {
        alert(response.message)
    }
  };

 

  return (
    <section className="bg-gray-50 dark:bg-gray-900 overflow-auto h-screen">
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto">
        <a className="mb-6 text-2xl font-semibold text-gray-900 dark:text-white">
          SADHA VIDEO
        </a>
        <div className="w-full text-left bg-white rounded-lg shadow dark:border sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
          <div className="p-6 space-y-6">
            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
              Sign up to your account
            </h1>
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Full Name
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full p-2.5 border rounded-lg bg-gray-50 text-gray-900 border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600 dark:placeholder-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Enter your Name"
                  required
                />
              </div>

              <div>
                <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Your email
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full p-2.5 border rounded-lg bg-gray-50 text-gray-900 border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600 dark:placeholder-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="name@company.com"
                  required
                />
              </div>

              <div>
                      <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Password</label>
                      <input type="password" name="password" id="password" placeholder="••••••••"     value={formData.password}
                  onChange={handleChange}  className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required />
                  </div>

              <div>
                <label htmlFor="companyName" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Company/Brand Name
                </label>
                <input
                  type="text"
                  name="companyName"
                  id="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  className="w-full p-2.5 border rounded-lg bg-gray-50 text-gray-900 border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600 dark:placeholder-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="e.g. Hollywood Films"
                  required
                />
              </div>

              <div>
                <label htmlFor="websiteUrl" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Website/Portfolio *
                </label>
                <input
                  type="text"
                  name="websiteUrl"
                  id="websiteUrl"
                  value={formData.websiteUrl}
                  onChange={handleChange}
                  className="w-full p-2.5 border rounded-lg bg-gray-50 text-gray-900 border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600 dark:placeholder-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="mywebsite.com"
                  required
                  
                  title="Please enter a valid URL (e.g., http://example.com)"
                />
              </div>

              {/* Group Size - Radio Buttons */}
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Size of your company *
                </label>
                <div className="w-full bg-gray-800 text-white rounded-lg p-4 flex flex-col gap-3">
                  {companySize.map((label) => (
                    <label key={label} className="flex items-center gap-3 cursor-pointer">
                      <input
                        type="radio"
                        name="companySize"
                        value={label}
                        checked={formData.companySize === label}
                        onChange={handleChange}
                        className="p-2 rounded-md focus:ring-2 focus:ring-blue-500"
                      />
                      {label}
                    </label>
                  ))}
                </div>
              </div>

              {/* Media Type - Checkboxes */}
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Type of Media *
                </label>
                <div className="w-full bg-gray-800 text-white rounded-lg p-4 flex flex-col gap-3">
                  {typesOfMedia.map((labelText, idx) => (
                    <label key={idx} className="flex items-center gap-3 cursor-pointer">
                      <input
                        type="checkbox"
                        name="mediaType"
                        value={labelText}
                        checked={formData.mediaType.includes(labelText)}
                        onChange={handleChange}
                        className="p-2 rounded-md focus:ring-2 focus:ring-blue-500"
                      />
                      {labelText}
                    </label>
                  ))}
                </div>
              </div>

              {/* Work Type - Radio Buttons */}
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Do you also offer Photography? *
                </label>
                <div className="w-full bg-gray-800 text-white rounded-lg p-4 flex flex-col gap-3">
                  {jobType.map((label) => (
                    <label key={label} className="flex items-center gap-3 cursor-pointer">
                      <input
                        type="radio"
                        name="jobType"
                        value={label}
                        checked={formData.jobType === label}
                        onChange={handleChange}
                        className="p-2 rounded-md focus:ring-2 focus:ring-blue-500"
                      />
                      {label}
                    </label>
                  ))}
                </div>
              </div>

              {/* Number of Clients - Radio Buttons */}
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Number of Client Projects per year *
                </label>
                <div className="w-full bg-gray-800 text-white rounded-lg p-4 flex flex-col gap-3">
                  {numberOfClients.map((label) => (
                    <label key={label} className="flex items-center gap-3 cursor-pointer">
                      <input
                        type="radio"
                        name="numberOfClients"
                        value={label}
                        checked={formData.numberOfClients === label}
                        onChange={handleChange}
                        className="p-2 rounded-md focus:ring-2 focus:ring-blue-500"
                      />
                      {label}
                    </label>
                  ))}
                </div>
              </div>

              {/* Project Size - Radio Buttons */}
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Average Size of each project (GB) *
                </label>
                <div className="w-full bg-gray-800 text-white rounded-lg p-4 flex flex-col gap-3">
                  {projectSize.map((label) => (
                    <label key={label} className="flex items-center gap-3 cursor-pointer">
                      <input
                        type="radio"
                        name="projectSize"
                        value={label}
                        checked={formData.projectSize === label}
                        onChange={handleChange}
                        className="p-2 rounded-md focus:ring-2 focus:ring-blue-500"
                      />
                      {label}
                    </label>
                  ))}
                </div>
              </div>

              {/* Delivery Type - Checkboxes */}
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Delivery Type *
                </label>
                <div className="w-full bg-gray-800 text-white rounded-lg p-4 flex flex-col gap-3">
                  {deliveryType.map((labelText, idx) => (
                    <label key={idx} className="flex items-center gap-3 cursor-pointer">
                      <input
                        type="checkbox"
                        name="deliveryType"
                        value={labelText}
                        checked={formData.deliveryType.includes(labelText)}
                        onChange={handleChange}
                        className="p-2 rounded-md focus:ring-2 focus:ring-blue-500"
                      />
                      {labelText}
                    </label>
                  ))}
                </div>
              </div>

              {/* Heard Option - Dropdown */}
              <div>
                <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Where did you hear about us?
                </label>
                <select
                  name="heardOption"
                  value={formData.heardOption}
                  onChange={handleChange}
                  className="w-full px-4 py-2 bg-gray-800 border border-gray-600 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="" disabled>
                    -- Select an option --
                  </option>
                  {heardOption.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>

              <button type="submit" className="w-full text-white bg-yellow-800 hover:bg-yellow-600 font-medium rounded-lg text-sm px-5 py-2.5 text-center">
                Register With Us
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SignUp;
